// extracted by mini-css-extract-plugin
export default {"container":"DefaultLayout_container__cbPg5"};